<template>
    <div>{{ statusText }}</div>
</template>

<script>
import auth from "../../auth";
import request from "../../repo/request";

export default {
    name: "LoginAdmin",
    data() {
        return {
            statusText: '登录中，请稍后...'
        }
    },
    mounted() {
        
        this.checkToken()
        
    },
    methods: {
        checkToken() {
            
            let token = this.$route.query.token
            let appId = this.$route.query.app_id
            let redirect = this.$route.query.redirect || '/login'
            
            console.log(redirect);
            
            request.post('/collocation/auth/check', {token}, (data) => {
                
                if (data.code !== 0) {
                    this.statusText = '登录失败，请联系管理员.'
                    return
                }
                
                auth.remember(token, data.data.info)
                
                auth.appId(appId)
                
                this.$router.push(redirect);
            });
        }
    }
}
</script>

<style scoped>

</style>